<template>
    <div class="payment-history card">
        <div class="card-header">
            <div>Payment history</div>
        </div>
        <div class="card-body">
            <div class="siot-table-wrapper">
                <div class="siot-table-header">
                    <div class="siot-table-header-left">
                        <div class="siot-table-search">
                            <div class="siot-table-search-field">
                                <input type="text" id="billingTransactionsSearch" v-model="search" placeholder="Search" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown"/>
                            </div>
                        </div>

                        <div class="siot-table-filter">
                            <button class="btn btn-primary filter-btn" id="billingTransactionsFilterButton" @click="toggleFilter()"><i class="fa fa-filter"></i>Filter</button>
                            <button class="btn btn-primary mobile-sort-btn" @click="shwoHideSort()"><i class="fa fa-sort" aria-hidden="true"></i>Sort</button>
                        </div>
                    </div>

                    <div class="siot-table-header-right">
                        <div class="siot-table-export">
                            <select id="exportSelect" class="form-control custom-select export-select" v-model="exportMode">
                                <option value="0" selected>Export: Current page</option>
                                <option value="1">Export: All pages</option>
                            </select>
                            <button @click="openExportModal()" class="btn btn-primary">Export</button>
                        </div>

                        <div class="siot-table-size">
                            <label for="size-page" class="show-label">Display:</label>
                            <select v-model="sortSettings.size" @change="getPayments(true)" id="size-page" class="form-control custom-select display">
                                <option selected value="40">40</option>
                                <option value="60">60</option>
                                <option value="80">80</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div v-if="mobileVisible" class="mobile-payments-wrapper">
                    <div class="list-mobile">
                        <div v-for="(item, index) in paymentsList" v-bind:key="index" class="item-mobile">
                            <div class="item-header-mobile">
                                <div class="info-wrapper-mobile">
                                    <strong>{{item.issuedAt}}</strong>
                                    <span>{{item.price}}</span>
                                </div>
                            </div>
                            <div class="data-table-mobile">
                                <div class="row-mobile">
                                    <div class="icon-mobile">
                                        <img src="../../assets/img/mobile-icons/mobile-icon2.svg" alt="">
                                    </div>
                                    <div class="info">
                                        <span class="value">{{item.entryType}}</span>
                                    </div>
                                </div>
                                <div class="row-mobile">
                                    <div class="icon-mobile">
                                        <img src="../../assets/img/mobile-icons/mobile-icon21.svg" alt="">
                                    </div>
                                    <div class="info">
                                        <span class="value">{{item.paymentSourceDetails}}</span>
                                    </div>
                                </div>
                                <div :class="[item.successful == true ? 'payment-success' : 'payment-failed', 'row-mobile']">
                                    <div class="icon-mobile">
                                        <img src="../../assets/img/mobile-icons/mobile-icon22.svg" alt="">
                                    </div>
                                    <div class="info">
                                        <span class="value">{{item.stripeDeclineCode }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="siot-table-content">
                    <div class="siot-table table-payment-history">
                        <table class="table b-table table-striped table-hover ">
                            <thead role="rowgroup">
                            <tr role="row">
                                <th role="columnheader" @click="changeSort(1)" :aria-sort="setAreaSort(1)">Date</th>
                                <th>Type</th>
                                <th>Payment Type</th>
                                <th role="columnheader" @click="changeSort(5)" :aria-sort="setAreaSort(5)">Amount</th>
                                <th>Status</th>
                                <th>Decline reason</th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr v-for="payment of paymentsList" :class="payment.successful == false && payment.chargeStatus != 'PENDING' ? 'payment-failed' : ''">
                                <td>{{payment.issuedAt}}</td>
                                <td>{{payment.entryType}}</td>
                                <td>{{payment.paymentSourceDetails}}</td>
                                <td>{{payment.price}}</td>
                                <td class="status-cell">{{payment.statusName}}</td>
                                <td>{{payment.stripeDeclineCode}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="no-sims" v-if="loading == false && noPayments == true">
                        <h2 class="text">You have no Payments to display <span v-if="search != ''">meeting your requirements.</span></h2>
                    </div>

                    <div class="loader" v-if="loading && noPayments == false">
                        <div class="sk-wave">
                            <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                        </div>
                    </div>
                </div>
                <div class="siot-table-footer">
                    <div class="siot-table-footer-center">
                        <nav v-if="paginationCount" aria-label="Page navigation example">
                            <paginate :page-count="paginationCount" v-model="sortSettings.page" :click-handler="paginationControll" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></paginate>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        <b-modal size="md" ref="selectExportFormat" id="selectExportFormat" centered hide-header hide-footer>
            <i class="fa fa-close" @click="closeExportModal"></i>
            <img src="../../assets/img/file-format.svg">
            <h3>Save export file as:</h3>
            <div>
                <button class="btn btn-primary csv" v-on:click="exportCsv()">CSV</button>
                <button class="btn btn-primary xls" v-on:click="exportXlsx()">XLSX</button>
            </div>
            <button class="btn btn-light" @click="closeExportModal()">Cancel</button>
        </b-modal>
        <FTSSort v-if="mobileSort.visible" :settingsSort="sortingSettings" :directionSort="sortSettings.desc" :columnSort="sortSettings.sort" v-on:hideSort="shwoHideSort" v-on:submitSort="submitSort"></FTSSort>

        <div class="filters">
            <div v-if="filtersShown" class="filters-box">
                <div class="inner-filters">
                    <div class="filters-content">
                        <div class="filters-columns">
                            <div class="filters-box-column time-period">
                                <h4>Time period</h4>
                                <div class="time-period-select">
                                    <div class="custom-control custom-radio">
                                        <input type="radio" id="TODAY" :value="1" name="time-period" class="custom-control-input" :checked="timePeriod == 1" v-model="timePeriod">
                                        <label class="custom-control-label" for="TODAY">Today</label>
                                    </div>
                                    <div class="custom-control custom-radio">
                                        <input type="radio" id="LAST_24_HOURS" :value="2" name="time-period" class="custom-control-input" :checked="timePeriod == 2" v-model="timePeriod">
                                        <label class="custom-control-label" for="LAST_24_HOURS">Last 24 hours</label>
                                    </div>
                                    <div class="custom-control custom-radio">
                                        <input type="radio" id="LAST_7_DAYS" :value="3" name="time-period" class="custom-control-input" :checked="timePeriod == 3" v-model="timePeriod">
                                        <label class="custom-control-label" for="LAST_7_DAYS">Last 7 days</label>
                                    </div>
                                    <div class="custom-control custom-radio">
                                        <input type="radio" id="LAST_30_DAYS" :value="4" name="time-period" class="custom-control-input" :checked="timePeriod == 4" v-model="timePeriod">
                                        <label class="custom-control-label" for="LAST_30_DAYS">Last 30 days</label>
                                    </div>
                                    <div class="custom-control custom-radio">
                                        <input type="radio" id="LAST_YEAR" :value="5" name="time-period" class="custom-control-input" :checked="timePeriod == 5" v-model="timePeriod">
                                        <label class="custom-control-label" for="LAST_YEAR">Last Year</label>
                                    </div>
                                    <div class="custom-control custom-radio">
                                        <input type="radio" id="custom-date" :value="6" name="time-period" class="custom-control-input" :checked="timePeriod == 6" v-model="timePeriod">
                                        <label class="custom-control-label" for="custom-date">Custom date</label>
                                    </div>
                                </div>
                                <div class="date-pickers-box">
                                    <div class="date-picker-box">
                                        <span class="date-picker-label">From</span>
                                        <date-picker :disabled="timePeriod != 6" v-model="startDate" class="datepicker" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                                    </div>
                                    <div class="date-picker-box">
                                        <span class="date-picker-label">To</span>
                                        <date-picker :disabled="timePeriod != 6" v-model="endDate" class="datepicker" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                                    </div>
                                    <span v-if="errorMsgs.dates != ''" class="error-message">{{errorMsgs.dates}}</span>
                                </div>
                            </div>
                            <div v-if="false" class="filters-box-column type">
                                <h4>Type</h4>
                                <div class="types-box">
                                    <FTScheckbox v-model="types.billing" :label="'Billing'"></FTScheckbox>
                                    <FTScheckbox v-model="types.order" :label="'Order'"></FTScheckbox>
                                    <span v-if="errorMsgs.types != ''" class="error-message">{{errorMsgs.types}}</span>
                                </div>
                            </div>
                            <div class="filters-box-column credit-cards">
                                <h4>Payment Type</h4>
                                <div class="credit-cards-inputs">
                                    <label v-for="cc of creditCards" class="FTScheckbox" :for="'cc-' + cc.creditCardId" :option-selected="cc.selected">
                                        <input class="FTScheckbox-check" :id="'cc-' + cc.creditCardId" type="checkbox" v-model="cc.selected" :checked="cc.selected">
                                        <span></span>
                                        <span class="FTScheckbox-content">{{cc.cardDescription}}</span>
                                    </label>
                                    <label v-for="ba of bankAccounts" class="FTScheckbox" :for="'ba-' + ba.accountId" :option-selected="ba.selected">
                                        <input class="FTScheckbox-check" :id="'ba-' + ba.accountId" type="checkbox" v-model="ba.selected" :checked="ba.selected">
                                        <span></span>
                                        <span class="FTScheckbox-content">{{ba.accountName}}</span>
                                    </label>
                                    <FTScheckbox v-model="paymentTypes.ACH" :label="'ACH'"></FTScheckbox>
                                    <FTScheckbox v-model="paymentTypes.wire" :label="'Wire'"></FTScheckbox>
                                    <FTScheckbox v-model="paymentTypes.cash" :label="'Cash'"></FTScheckbox>
                                    <FTScheckbox v-model="paymentTypes.other" :label="'Other'"></FTScheckbox>
                                    <span v-if="errorMsgs.paymentTypes != ''" class="error-message">{{errorMsgs.paymentTypes}}</span>
                                </div>
                            </div>
                            <div class="filters-box-column amount">
                                <h4>Amount</h4>
                                <div class="amount-inputs">
                                    <div class="input-box">
                                        <span>From</span>
                                        <input v-model="amount.from" type="number" placeholder="Amount">
                                    </div>
                                    <div class="input-box">
                                        <span>To</span>
                                        <input v-model="amount.to" type="number" placeholder="Amount">
                                    </div>
                                    <span v-if="errorMsgs.amount != ''" class="error-message">{{errorMsgs.amount}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="filters-box-bottom">
                        <div class="left-side">
                            <button class="btn btn-light" @click="setDefaultFilters()">Set default</button>
                        </div>
                        <div class="right-side">
                            <button class="btn btn-light" @click="setInitialFilters()">Cancel</button>
                            <button class="btn btn-primary filter-confirm" @click="setFilters()">Filter</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Paginate from 'vuejs-paginate'
    import Axios from 'axios'
    import DatePicker from 'vue2-datepicker'
    import globalStore from '../../variables';
    import FTScheckbox from "../../ftsComponents/FTScheckbox";
    import FTSSort from "../../ftsComponents/FTSSort";

    export default {
        name: "PaymentHistory",
        components: {
            Paginate,
            DatePicker,
            FTScheckbox,
            FTSSort,
        },
        data() {
            return {
                sortingSettings: [
                    {
                        label: 'Date',
                        column: 1
                    },
                    {
                        label: 'Amount',
                        column: 5
                    },
                ],
                mobileSort: {
                    column: 0,
                    direction: 0,
                    visible: false
                },
                mobileVisible: false,
                filtersShown: false,
                filter: '&timeframeFilter=LAST_30_DAYS',
                initialFilter: {},
                timePeriod: 4,
                startDate: null,
                endDate: null,
                search: '',
                paginationCount: false,
                loading: false,
                typingTimer: null,
                noPayments: false,
                sortSettings: {
                    page: 1,
                    size: 40,
                    sort: 1,
                    desc: true
                },
                langDataPicker: {
                    days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
                    placeholder: {
                        date: 'Select Date',
                        dateRange: 'Select Date'
                    }
                },
                exportMode: 0,
                visibleMobileOptions: false,
                errorMsgs: {
                    dates: '',
                    types: '',
                    amount: '',
                    paymentTypes: ''
                },
                types: {
                    billing: true,
                    order: true
                },
                creditCards: [],
                bankAccounts: [],
                initialCreditCards: [],
                initialBankAccounts: [],
                amount: {
                    from: '',
                    to: ''
                },
                paymentTypes: {
                    ACH: true,
                    wire: true,
                    cash: true,
                    other: true
                },
                paymentsList: []
            }
        },
        methods: {
            submitSort(value) {
                this.sortSettings.sort = value.column;
                this.sortSettings.desc = value.direction;
                this.getPayments(true);
            },
            shwoHideSort() {
                this.mobileSort.visible = (this.mobileSort.visible == true) ? false : true;
            },
            showMobileElements() {
                const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

                if (width < 992) {
                    this.mobileVisible = true;
                } else {
                    this.mobileVisible = false;
                }
            },
            searchKeyUp() {
                clearTimeout(this.typingTimer)
                this.typingTimer = setTimeout(() => {
                    this.getPayments(true)
                }, 500)
            },
            searchKeyDown() {
                clearTimeout(this.typingTimer)
            },
            toggleFilter() {
                if (this.filtersShown) {
                    this.setInitialFilters();
                } else {
                    this.showFilters();
                }
            },
            showFilters() {
                this.filtersShown = true;
                this.initialFilters = {
                    timePeriod: this.timePeriod,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    types: {
                        billing: this.types.billing,
                        order: this.types.order
                    },
                    amount: {
                        from: this.amount.from,
                        to: this.amount.to
                    },
                    paymentTypes: {
                        ACH: this.paymentTypes.ACH,
                        wire: this.paymentTypes.wire,
                        cash: this.paymentTypes.cash,
                        other: this.paymentTypes.other
                    }
                }
                this.initialCreditCards = []
                for (let cc of this.creditCards) {
                    if (cc.selected) {
                        this.initialCreditCards.push({creditCardId: cc.creditCardId, cardDescription: cc.cardDescription, selected: true})
                    } else {
                        this.initialCreditCards.push({creditCardId: cc.creditCardId, cardDescription: cc.cardDescription, selected: false})
                    }
                }
                this.initialBankAccounts = []
                for (let ba of this.bankAccounts) {
                    if (ba.selected) {
                        this.initialBankAccounts.push({accountId: ba.accountId, accountName: ba.accountName, selected: true})
                    } else {
                        this.initialBankAccounts.push({accountId: ba.accountId, accountName: ba.accountName, selected: false})
                    }
                }
            },
            hideFilters() {
                this.filtersShown = false;
            },
            changeSort(sortId) {
                if (sortId == this.sortSettings.sort) {
                    this.sortSettings.desc = !this.sortSettings.desc
                }
                this.sortSettings.sort = sortId
                this.getPayments(false)
            },
            setAreaSort(sortId) {
                if (sortId != this.sortSettings.sort) {
                    return 'none'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc) {
                    return 'descending'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc == false) {
                    return 'ascending'
                }
            },
            paginationControll(ev) {
                this.sortSettings.page = ev;
                this.getPayments(false);
            },
            setFilters() {
                this.errorMsgs.dates = ''
                this.errorMsgs.types = ''
                this.errorMsgs.paymentTypes = ''
                this.errorMsgs.amount = ''
                let errorsCounter = 0
                this.filter = ''
                let today = new Date
                today = new Date(today.getFullYear() + '-' + ("0" + (today.getMonth() + 1)).slice(-2) + '-' + ("0" + today.getDate()).slice(-2));
                if (this.timePeriod == 1) {
                    this.filter = "&timeframeFilter=TODAY"
                } else if (this.timePeriod == 2) {
                    this.filter = "&timeframeFilter=LAST_24_HOURS"
                } else if (this.timePeriod == 3) {
                    this.filter = "&timeframeFilter=LAST_7_DAYS"
                } else if (this.timePeriod == 4) {
                    this.filter = "&timeframeFilter=LAST_30_DAYS"
                } else if (this.timePeriod == 5) {
                    this.filter = "&timeframeFilter=LAST_YEAR"
                } else if (this.timePeriod == 6 && (this.startDate > this.endDate)) {
                    this.errorMsgs.dates = 'End of period must be later than start.'
                    errorsCounter++;
                } else if (this.timePeriod == 6 && (this.startDate == null || this.endDate == null || this.startDate == '' || this.endDate == '')) {
                    this.errorMsgs.dates = 'Both dates must be picked.'
                    errorsCounter++;
                } else if (this.timePeriod == 6 && (new Date(this.startDate) > new Date(today) || new Date(this.endDate) > new Date(today))) {
                    this.errorMsgs.dates = 'Dates can not be from the future.'
                    errorsCounter++;
                } else {
                    this.filter = '&startDate=' + this.startDate + '&endDate=' + this.endDate
                }

                if (this.types.order == false && this.types.billing == false) {
                    this.errorMsgs.types = 'At least one type must be selected'
                    errorsCounter++;
                } else {
                    let types = ''
                    if (this.types.order) {
                        types = types + '&type=ORDER'
                    }
                    if (this.types.billing) {
                        types = types + '&type=BILLING'
                    }
                    this.filter = this.filter + types
                }
                if ((this.amount.from && this.amount.to && (this.amount.from > this.amount.to)) || (this.amount.from && this.amount.to && this.amount.from == this.amount.to)) {
                    this.errorMsgs.amount = 'Amount from must be lower than amount to.'
                    errorsCounter++;
                } else if ((this.amount.from && this.amount.from < 0) || (this.amount.to && this.amount.to < 0)) {
                    this.errorMsgs.amount = 'Amounts can not be lower than zero.'
                    errorsCounter++;
                } else {
                    if (this.amount.from) {
                        this.filter = this.filter + '&amountFrom=' + this.amount.from
                    }
                    if (this.amount.to) {
                        this.filter = this.filter + '&amountTo=' + this.amount.to
                    }
                }

                let ccSelected = []
                for (let cc of this.creditCards) {
                    if (cc.selected) {
                        ccSelected.push(cc.creditCardId)
                    }
                }

                let baSelected = []
                for (let ba of this.bankAccounts) {
                    if (ba.selected) {
                        baSelected.push(ba.accountId)
                    }
                }

                if (ccSelected.length == 0 && baSelected.length == 0 && this.paymentTypes.ACH == false && this.paymentTypes.wire == false && this.paymentTypes.cash == false && this.paymentTypes.other == false) {
                    this.errorMsgs.paymentTypes = 'At least one Payment Type must be selected'
                    errorsCounter++;
                } else if (ccSelected.length != this.creditCards.length || baSelected.length != this.bankAccounts.length || !this.paymentTypes.ACH || !this.paymentTypes.wire || !this.paymentTypes.cash || !this.paymentTypes.other) {
                    let paymentTypeParsed = ''
                    if (ccSelected.length) {
                        for (let cc of ccSelected) {
                            paymentTypeParsed = paymentTypeParsed + '&creditCards=' + cc
                        }
                    }
                    if (baSelected.length) {
                        for (let ba of baSelected) {
                            paymentTypeParsed = paymentTypeParsed + '&bankAccounts=' + ba
                        }
                    }
                    if (this.paymentTypes.ACH) {
                        paymentTypeParsed = paymentTypeParsed + '&manualPayments=ACH'
                    }
                    if (this.paymentTypes.wire) {
                        paymentTypeParsed = paymentTypeParsed + '&manualPayments=WIRE'
                    }
                    if (this.paymentTypes.cash) {
                        paymentTypeParsed = paymentTypeParsed + '&manualPayments=CASH'
                    }
                    if (this.paymentTypes.other) {
                        paymentTypeParsed = paymentTypeParsed + '&manualPayments=OTHER'
                    }

                    this.filter = this.filter + paymentTypeParsed
                }

                if (errorsCounter > 0) {
                    return false
                } else {
                    this.getPayments(true)
                    this.hideFilters()
                }
            },
            setDefaultFilters() {
                this.timePeriod = 1
                this.types.billing = true
                this.types.order = true
                for (let cc of this.creditCards) {
                    cc.selected = true
                }
                for (let ba of this.bankAccounts) {
                    ba.selected = true
                }
                this.amount.from = ''
                this.amount.to = ''
                this.paymentTypes.ACH = true
                this.paymentTypes.wire = true
                this.paymentTypes.cash = true
                this.paymentTypes.other = true
            },
            setInitialFilters() {
                this.errorMsgs = {
                    dates: '',
                    amount: '',
                    types: '',
                    paymentTypes: ''
                }

                this.timePeriod = this.initialFilters.timePeriod
                this.startDate = this.initialFilters.startDate
                this.endDate = this.initialFilters.endDate
                this.types = {
                    billing: this.initialFilters.types.billing,
                    order: this.initialFilters.types.order
                }
                this.amount = {
                    from: this.initialFilters.amount.from,
                    to: this.initialFilters.amount.to
                }
                this.creditCards = []
                for (let cc of this.initialCreditCards) {
                    if (cc.selected) {
                        this.creditCards.push({creditCardId: cc.creditCardId, cardDescription: cc.cardDescription, selected: true})
                    } else {
                        this.creditCards.push({creditCardId: cc.creditCardId, cardDescription: cc.cardDescription, selected: false})
                    }
                }
                this.bankAccounts = []
                for (let ba of this.initialBankAccounts) {
                    if (ba.selected) {
                        this.bankAccounts.push({accountId: ba.accountId, accountName: ba.accountName, selected: true})
                    } else {
                        this.bankAccounts.push({accountId: ba.accountId, accountName: ba.accountName, selected: false})
                    }
                }
                this.paymentTypes = {
                    ACH: this.initialFilters.paymentTypes.ACH ? true : false,
                    wire: this.initialFilters.paymentTypes.wire ? true : false,
                    cash: this.initialFilters.paymentTypes.cash ? true : false,
                    other: this.initialFilters.paymentTypes.other ? true : false
                }
                this.hideFilters()
            },
            getPaymentsPagination() {
                let search = this.search != '' ? '&search=' + this.search : ''
                Axios.get(globalStore.data.restApiUrl + '/payment-history/page-count?size=' + this.sortSettings.size + search + this.filter)
                    .then(response => {
                        this.paginationCount = Number(response.data) //here
                    })
            },
            getPayments(resetPage) {
                this.loading = true
                if (resetPage) {
                    this.sortSettings.page = 1
                    this.getPaymentsPagination()
                }
                let search = this.search != '' ? '&search=' + this.search : ''
                Axios.get(globalStore.data.restApiUrl + '/payment-history/list?page=' + this.sortSettings.page + '&size=' + this.sortSettings.size + '&sort=' + this.sortSettings.sort + '&desc=' + this.sortSettings.desc + search + this.filter)
                    .then(response => {
                        this.noPayments = false
                        this.paymentsList = []
                        for (let item of response.data) {
                            let type = null
                            if (item.billingChargeType == 'BILLING') {
                                type = 'Billing'
                            } else if (item.billingChargeType == 'ORDER') {
                                type = 'Order'
                            } else {
                                type = 'N/A'
                            }
                            let template = {
                                issuedAt: item.issuedAt,
                                entryType: type,
                                price: '$' + item.price.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}),
                                stripeDeclineCode: item.stripeDeclineCode,
                                successful: item.successful,
                                chargeStatus: item.chargeStatus,
                                statusName: item.chargeStatus.replace("_", " ").toLowerCase(),
                                paymentSourceDetails: item.paymentSourceDetails
                            }

                            this.paymentsList.push(template)
                        }
                        if (response.data.length == 0) {
                            this.noPayments = true
                        }
                        this.loading = false
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Error',
                            text: 'Something went wrong during getting payment history, please contact support.',
                            duration: 5000,
                        });
                        this.loading = false
                        console.log(error)
                    })
            },
            getCreditCards() {
                Axios.get(globalStore.data.restApiUrl + '/payment-history/used-payment-methods')
                    .then(response => {
                        this.creditCards = []
                        this.bankAccounts = []
                        if (response.data.creditCards) {
                            for (let cc of response.data.creditCards) {
                                cc.selected = true
                                this.creditCards.push(cc)
                            }
                        }
                        if (response.data.bankAccounts) {
                            for (let bankAccount of response.data.bankAccounts) {
                                bankAccount.selected = true
                                this.bankAccounts.push(bankAccount)
                            }
                        }

                    }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Error',
                        text: 'Error Retrieving Credit Card Details - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
            },
            openExportModal() {
                this.$refs['selectExportFormat'].show()
            },
            closeExportModal() {
                this.$refs['selectExportFormat'].hide()
            },
            exportCsv() {
                this.$refs['selectExportFormat'].hide()

                let mode = ''
                if (this.exportMode == 0) {
                    mode = '?allResults=false'
                } else {
                    mode = '?allResults=true'
                }

                Axios.get(globalStore.data.restApiUrl + "/payment-history/csv" + mode + this.filter)
                    .then(response => {
                        let csvContent = "data:text/csv;charset=utf-8," + response.data;
                        var fileLink = document.createElement('a');fileLink.href = csvContent;
                        fileLink.setAttribute('download', 'Payment history.csv');
                        document.body.appendChild(fileLink);
                        fileLink.click();
                        this.loadingCompniesList = false;
                    }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'SIMs export went wrong',
                        text: 'Something went wrong during exporting payment history. Please contact with support.',
                        duration: 3000,
                    });
                    console.log(error);
                });
            },
            exportXlsx() {
                this.$refs['selectExportFormat'].hide()

                let mode = ''
                if (this.exportMode == 0) {
                    mode = '?allResults=false'
                } else {
                    mode = '?allResults=true'
                }

                Axios.get(globalStore.data.restApiUrl + "/payment-history/xlsx" + mode + this.filter, {responseType: 'blob'})
                    .then((response) => {
                        const fileLink = URL.createObjectURL(new Blob([response.data],
                            {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                            )
                        );
                        const link = document.createElement('a')
                        link.href = fileLink
                        link.setAttribute('download', 'Payment history export.xlsx')
                        document.body.appendChild(link)
                        link.click()
                        this.loadingCompniesList = false;
                    }).catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'SIMs export went wrong',
                        text: 'Something went wrong during exporting payment history. Please contact with support.',
                        duration: 3000,
                    });
                    console.log(error);
                });
            }
        },
        mounted() {
            this.showMobileElements();
            this.getPayments(true);
            this.getCreditCards()
        }
    }
</script>

<style lang="scss">
    .payment-history {
        .card-body {
            padding: 20px 0;
        }
    }
    .filters {
        .filter-btn {
            margin-left: 20px;
        }
        .filters-box {
            position: fixed;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(0, 0, 0, 0.6);
            z-index: 4000;
            .inner-filters {
                background-color: #fff;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                .filters-columns {
                    display: flex;
                    flex-wrap: nowrap;

                    .filters-box-column {
                        position: relative;
                        display: flex;
                        flex-direction: column;
                        border-right: 1px solid #f2f2f2;
                        padding: 20px 30px;

                        &:first-child {
                            padding-left: 20px;
                        }

                        &:last-child {
                            border-right: 0;
                            padding-right: 20px;
                        }

                        h4 {
                            font-size: 15px;
                            margin: 0 0 15px;
                            font-weight: 700;
                        }

                        &.time-period {
                            .time-period-select {
                                display: flex;
                                flex-direction: column;

                                .custom-radio {
                                    margin: 10px 0;

                                    .custom-control-label::before {
                                        background-color: #f2f2f2;
                                    }

                                    .custom-control-input:checked ~ .custom-control-label {
                                        &::before {
                                            background-color: #f2f2f2;
                                        }

                                        &::after {
                                            background-image: url('data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'-4 -4 8 8\'%3e%3ccircle r=\'3\' fill=\'%233a4149\'/%3e%3c/svg%3e');
                                        }
                                    }
                                }
                            }

                            .date-pickers-box {
                                position: relative;
                                display: flex;

                                .date-picker-box {
                                    display: flex;
                                    flex-direction: column;
                                    margin-right: 20px;

                                    &:last-child {
                                        margin-right: 0;
                                    }

                                    .datepicker {
                                        max-width: 150px;
                                    }
                                }
                            }
                        }

                        &.type {
                            width: 300px;

                            .types-box {
                                position: relative;

                                .FTScheckbox {
                                    .FTScheckbox-content {
                                        white-space: nowrap;
                                    }
                                }
                            }
                        }

                        &.amount {
                            .amount-inputs {
                                position: relative;
                                display: flex;
                                margin-bottom: 10px;

                                .input-box {
                                    margin-right: 15px;

                                    span {
                                        margin-right: 10px;
                                    }

                                    &:last-child {
                                        margin-right: 0;
                                    }

                                    input[type="number"] {
                                        width: 100px;
                                        border: 1px solid #c9cfd4;
                                        padding: 6px 10px;
                                        -webkit-border-radius: 5px;
                                        -moz-border-radius: 5px;
                                        border-radius: 5px;
                                    }
                                }
                            }

                            .amount-types {
                                position: relative;

                                .amount-type {
                                    display: flex;
                                    align-items: center;
                                    justify-content: flex-start;

                                    .FTScheckbox {
                                        width: 40%;
                                    }

                                    &.charges {
                                        i {
                                            color: #FF6F00;
                                        }
                                    }

                                    &.credit {
                                        i {
                                            color: #00B406;
                                        }
                                    }
                                }
                            }
                        }

                        &.credit-cards {
                            width: 300px;

                            .credit-cards-inputs {
                                position: relative;

                                .FTScheckbox {
                                    .FTScheckbox-content {
                                        white-space: nowrap;
                                    }
                                }
                            }
                        }

                        span.error-message {
                            position: absolute;
                            bottom: -16px;
                            left: 0;
                            padding-bottom: 0;
                            font-size: 12px;
                            color: red;
                            white-space: nowrap;
                        }
                    }
                }

                .filters-box-bottom {
                    display: flex;
                    justify-content: space-between;
                    padding: 10px 20px 12px;
                    border-top: 1px solid #f2f2f2;
                    background-color: #f2f2f2;
                    text-align: center;
                    cursor: pointer;

                    .right-side {
                        .filter-confirm {
                            margin-left: 10px;
                        }
                    }
                }
            }
        }
    }
    .payment-history {
        position: relative;
        background-color: #fff;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        border: 1px solid #c8ced3;
        h1 {
            margin: 20px;
            font-size: 15px;
        }

        .filter-row {
            .left-side {
                display: flex;
                .options-mobile {
                    display: none;
                }

            }
            .text-right {
                .exports {
                    display: flex;
                    margin-right: 20px;
                    .export-select {
                        min-width: 120px;
                        margin-right: 8px;
                    }
                }
            }
        }
        .fts-table {
            position: relative;
            min-height: 550px;
            .centered {
                padding-top: 20px;
            }
        }
        .table-payment-history {
            tbody {
                tr {
                    td {
                        .info-icon {
                            display: none;
                            margin-left: 12px;
                        }
                        &.status-cell {
                            text-transform: capitalize;
                        }
                    }
                }
                .payment-failed {
                    td {
                        color: #FC4D4D;
                        .info-icon {
                            display: initial;
                            &:after {
                                content: 'Payment failed';
                                background-color: #000;
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }

        .loader,
        .no-payments {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;

            background-color: rgba(255, 255, 255, 0.7);

            display: flex;
            justify-content: center;
            align-items: center;
            align-content: center;

            .sk-wave {
                height: 60px;
                .sk-rect {
                    width: 3px;
                    background-color: #39c354;
                    border-radius: 4px;
                }
            }

            .text {
                margin-top: 20px;
                text-align: center;
                font-size: 15px;
                font-weight: 700;
            }

            h2.text {
                margin-top: 100px;
            }
        }
    }

    #selectExportFormat___BV_modal_body_ {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        i {
            position: absolute;
            top: 20px;
            right: 20px;
            font-size: 16px;
            cursor: pointer;
        }

        h3 {
            font-size: 15px;
            margin-top: 8px;
            margin-bottom: 20px;
        }

        .btn {
            width: 100px;
        }

        .btn-primary {
            margin: 0 10px 20px;
        }

        .btn-light {
            margin: 10px 0 0;
        }

        .csv {
            background-color: #00559F;
            border-color: #00559F;
        }
        .xls {
            background-color: #207245;
            border-color: #207245;
        }
    }

    .dark-theme {
        .payment-history {
            .table-payment-history {
                tbody {
                    .payment-failed {
                        td {
                            color: #FC4D4D !important;
                        }
                    }
                }
            }
            .filter-row {
                .left-side {

                }
            }
            .loader,
            .no-payments {
                background-color: rgba(0, 0, 0, 0.4);
            }
        }
        #selectExportFormat___BV_modal_body_ {
            background-color: #3a4149;
            color: #ffffff;
        }

        .filters {
            .filters-box {
                .inner-filters {
                    background-color: #3a4149;
                    .filters-columns {
                        .filters-box-column {
                            border-color: #1a1c1d;
                            &.amount {
                                .amount-inputs {
                                    .input-box {
                                        input[type="number"] {
                                            background-color: #515b65;
                                            color: #fff;
                                            border-color: #1a1c1d;
                                            &::placeholder {
                                                color: #ffffff;
                                            }
                                            &:focus {
                                                outline: none;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .filters-box-bottom {
                        background-color: #2f353a;
                        border-color: #1a1c1d;
                    }

                }
            }
        }
    }
</style>
